// API Gateway URL for regular endpoints
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || 'https://api-fallback-url').replace(/\/+$/, '')

// Function URL for streaming endpoint  
export const STREAMING_URL = (import.meta.env.VITE_STREAMING_URL || 'https://streaming-fallback-url').replace(/\/+$/, '')

export const GOOGLE_CLIENT_ID =
  '747365686519-t9cpu8cu31sv6jgru2n3r1llrfrjgcj6.apps.googleusercontent.com'
